export const NOOK_PAY_ENTITY = {
  name   : "Nook Pay Technology Pvt Ltd",
  address: "5th Floor, Tower A, Cyber Hub, Gurugram, Haryana 122002",
  gstin  : "06AAACC1234A1Z5",
  email  : "info@nookpay.tech"
};

export const NOOK_PAY_BANK_DETAILS = {
  beneficiary   : NOOK_PAY_ENTITY.name,
  bank_name     : "HDFC Bank",
  account_number: "501200XXXX4567",
  ifsc          : "HDFC0001234"
};
